import moment from "moment";

const initialState = {
  dashboard: {
    loading: {},
    error: {},

    filters: {
      dateFrom: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      dateTo: moment()
        .add(1, "day")
        .format("YYYY-MM-DD"),
      clusterInclude: null,
      logicalLocationInclude: null,
      geoLocationInclude: null,
      criticalMomentInclude: null
      // clusterId : ..., criticalMomentId : ...,  geoLocationId: ..., logicalLocationId : ..., channelId : ...
    },

    values: [],
    /*
    environment: {},
    service: {},
    food: {},
    drink: {},
    willingnessToReturn: {},
    willingnessToRecommend: {},
    satisfaction: {},
    offerSampler: [{}],
    willingnessToReturnHist: [{ serie: [] }],
    willingnessToRecommendHist: [{ serie: [] }],
    satisfactionHist: [{ serie: [] }],
    offerSamplerHist: [{ serie: [] }],
    nps: [{}],
    loyalty: [{ loyalty: 0 }],
    experience: [
      {
        general: { name: null, value: null },
        loyalty: { name: null, value: null },
        experiences: []
      }
    ],
    experienceHist: [{ serie: [] }],
    sentimentAnalysis: [],
    sentimentComments: [],
    lastComments: [],
    satisfactionByChannel: [],
    experienceByTerritory: { groups: [] },
    experienceByPointSale: { groups: [] },
    experienceByCriticalMoment: { groups: [] },
    */
    alerts: [
      {
        answered: 0,
        not_handled: 0,
        in_progress: 0,
        closed: 0
      }
    ],

    //
  },
  social: {
    loading: false,
    error: {},
    facebook: [],
    twitter: []
    // socialFollowers: [],
    // fbTotals: [],
    // fbReactions: [],
    // fbByUsers: [],
    // twFollowers: [],
    // twPosts: [],
    // twHashtags: [],
    // igPosts: [],
    // igHashtags: [],
    // sentimentAnalysisSocialData: [],
    // textAnalysisSocialData: [],
    // filters: {},
    // profileBrands: []
  },
  reports: {
    currentReport: null
  },
  cocreation: {},
  actionPlans: {
    dashboard: [],
    currentActionPlan: []
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./src/utils/initialState.js